import { z } from "@/hooks/schema";
import { Form } from "@/components/Form";
import { Input } from "@/components/ui/input";

export const documentsSchema = z.object({
  ctps_number: z.string().optional(),
  ctps_series: z.string().optional(),
  ctps_check_digit: z.string().optional(),
  ctps_state: z.string().optional(),
  ctps_issue_date: z.string().optional(),
  ctps_expiry_date: z.string().optional(),
  pis_pasep: z.string().optional(),
  rg_number: z.string().optional(),
  rg_issuing_agency: z.string().optional(),
  rg_state: z.string().optional(),
  rg_issue_date: z.string().optional(),
  rg_expiry_date: z.string().optional(),
  voter_registration_number: z.string().optional(),
  voter_registration_zone: z.string().optional(),
  voter_registration_section: z.string().optional(),
  military_certificate_number: z.string().optional(),
  military_certificate_series: z.string().optional(),
  military_certificate_type: z.string().optional(),
  military_certificate_category: z.string().optional(),
  military_csm_oam: z.string().optional(),
  military_rm_dn_comar: z.string().optional(),
  driver_license_number: z.string().optional(),
  professional_class_body: z.string().optional(),
  professional_class_issuer: z.string().optional(),
  professional_class_state: z.string().optional(),
  professional_class_issue_date: z.string().optional(),
  professional_class_expiry_date: z.string().optional(),
  immigration_arrival_year: z.string().optional(),
  immigration_visa_type: z.string().optional(),
});

export const DOCUMENTS_OMIT_WHEN_EMPTY = [
  "ctps_issue_date",
  "ctps_expiry_date",
  "rg_issue_date",
  "rg_expiry_date",
  "professional_class_issue_date",
  "professional_class_expiry_date",
];

const SectionLabel = ({ children }: { children: React.ReactNode }) => (
  <label className="text-sm font-medium text-muted-foreground">
    {children}
  </label>
);

export const DocumentsStep = () => {
  return (
    <>
      <SectionLabel>CTPS</SectionLabel>
      <Form.Row>
        <Form.Field name="ctps_number">
          {({ field }) => (
            <Form.Item>
              <Form.Label>Número</Form.Label>
              <Form.Control>
                <Input {...field} placeholder="Número" />
              </Form.Control>
            </Form.Item>
          )}
        </Form.Field>
        <Form.Field name="ctps_series">
          {({ field }) => (
            <Form.Item>
              <Form.Label>Série</Form.Label>
              <Form.Control>
                <Input {...field} placeholder="Série" />
              </Form.Control>
            </Form.Item>
          )}
        </Form.Field>
      </Form.Row>
      <Form.Row>
        <Form.Field name="ctps_check_digit">
          {({ field }) => (
            <Form.Item>
              <Form.Label>DV</Form.Label>
              <Form.Control>
                <Input {...field} placeholder="DV" />
              </Form.Control>
            </Form.Item>
          )}
        </Form.Field>
        <Form.Field name="ctps_state">
          {({ field }) => (
            <Form.Item>
              <Form.Label>UF</Form.Label>
              <Form.Control>
                <Input {...field} placeholder="Ex: CE" maxLength={2} />
              </Form.Control>
            </Form.Item>
          )}
        </Form.Field>
      </Form.Row>
      <Form.Row>
        <Form.Field name="ctps_issue_date">
          {({ field }) => (
            <Form.Item>
              <Form.Label>Emissão</Form.Label>
              <Form.Control>
                <Input {...field} type="date" />
              </Form.Control>
            </Form.Item>
          )}
        </Form.Field>
        <Form.Field name="ctps_expiry_date">
          {({ field }) => (
            <Form.Item>
              <Form.Label>Validade (imigração)</Form.Label>
              <Form.Control>
                <Input {...field} type="date" />
              </Form.Control>
            </Form.Item>
          )}
        </Form.Field>
      </Form.Row>

      <SectionLabel>PIS/PASEP</SectionLabel>
      <Form.Row>
        <Form.Field name="pis_pasep">
          {({ field }) => (
            <Form.Item>
              <Form.Control>
                <Input {...field} placeholder="PIS/PASEP" />
              </Form.Control>
            </Form.Item>
          )}
        </Form.Field>
      </Form.Row>

      <SectionLabel>RG</SectionLabel>
      <Form.Row>
        <Form.Field name="rg_number">
          {({ field }) => (
            <Form.Item>
              <Form.Label>Número</Form.Label>
              <Form.Control>
                <Input {...field} placeholder="Número" />
              </Form.Control>
            </Form.Item>
          )}
        </Form.Field>
        <Form.Field name="rg_issuing_agency">
          {({ field }) => (
            <Form.Item>
              <Form.Label>Órgão Emissor</Form.Label>
              <Form.Control>
                <Input {...field} placeholder="Ex: SSP" />
              </Form.Control>
            </Form.Item>
          )}
        </Form.Field>
      </Form.Row>
      <Form.Row>
        <Form.Field name="rg_state">
          {({ field }) => (
            <Form.Item>
              <Form.Label>UF</Form.Label>
              <Form.Control>
                <Input {...field} placeholder="Ex: CE" maxLength={2} />
              </Form.Control>
            </Form.Item>
          )}
        </Form.Field>
        <Form.Field name="rg_issue_date">
          {({ field }) => (
            <Form.Item>
              <Form.Label>Emissão</Form.Label>
              <Form.Control>
                <Input {...field} type="date" />
              </Form.Control>
            </Form.Item>
          )}
        </Form.Field>
      </Form.Row>
      <Form.Row>
        <Form.Field name="rg_expiry_date">
          {({ field }) => (
            <Form.Item>
              <Form.Label>Validade (imigração)</Form.Label>
              <Form.Control>
                <Input {...field} type="date" />
              </Form.Control>
            </Form.Item>
          )}
        </Form.Field>
      </Form.Row>

      <SectionLabel>Título de Eleitor</SectionLabel>
      <Form.Row>
        <Form.Field name="voter_registration_number">
          {({ field }) => (
            <Form.Item>
              <Form.Label>Número</Form.Label>
              <Form.Control>
                <Input {...field} placeholder="Número" />
              </Form.Control>
            </Form.Item>
          )}
        </Form.Field>
        <Form.Field name="voter_registration_zone">
          {({ field }) => (
            <Form.Item>
              <Form.Label>Zona</Form.Label>
              <Form.Control>
                <Input {...field} placeholder="Zona" />
              </Form.Control>
            </Form.Item>
          )}
        </Form.Field>
        <Form.Field name="voter_registration_section">
          {({ field }) => (
            <Form.Item>
              <Form.Label>Seção</Form.Label>
              <Form.Control>
                <Input {...field} placeholder="Seção" />
              </Form.Control>
            </Form.Item>
          )}
        </Form.Field>
      </Form.Row>

      <SectionLabel>Certificado Militar</SectionLabel>
      <Form.Row>
        <Form.Field name="military_certificate_number">
          {({ field }) => (
            <Form.Item>
              <Form.Label>Número</Form.Label>
              <Form.Control>
                <Input {...field} placeholder="Número" />
              </Form.Control>
            </Form.Item>
          )}
        </Form.Field>
        <Form.Field name="military_certificate_series">
          {({ field }) => (
            <Form.Item>
              <Form.Label>Série</Form.Label>
              <Form.Control>
                <Input {...field} placeholder="Série" />
              </Form.Control>
            </Form.Item>
          )}
        </Form.Field>
      </Form.Row>
      <Form.Row>
        <Form.Field name="military_certificate_type">
          {({ field }) => (
            <Form.Item>
              <Form.Label>Tipo</Form.Label>
              <Form.Control>
                <Input {...field} placeholder="Tipo" />
              </Form.Control>
            </Form.Item>
          )}
        </Form.Field>
        <Form.Field name="military_certificate_category">
          {({ field }) => (
            <Form.Item>
              <Form.Label>Categoria</Form.Label>
              <Form.Control>
                <Input {...field} placeholder="Categoria" />
              </Form.Control>
            </Form.Item>
          )}
        </Form.Field>
      </Form.Row>
      <Form.Row>
        <Form.Field name="military_csm_oam">
          {({ field }) => (
            <Form.Item>
              <Form.Label>CSM/OAM</Form.Label>
              <Form.Control>
                <Input {...field} placeholder="CSM/OAM" />
              </Form.Control>
            </Form.Item>
          )}
        </Form.Field>
        <Form.Field name="military_rm_dn_comar">
          {({ field }) => (
            <Form.Item>
              <Form.Label>RM/DN/COMAR</Form.Label>
              <Form.Control>
                <Input {...field} placeholder="RM/DN/COMAR" />
              </Form.Control>
            </Form.Item>
          )}
        </Form.Field>
      </Form.Row>

      <SectionLabel>CNH e Órgão de Classe</SectionLabel>
      <Form.Row>
        <Form.Field name="driver_license_number">
          {({ field }) => (
            <Form.Item>
              <Form.Label>Habilitação</Form.Label>
              <Form.Control>
                <Input {...field} placeholder="Número da CNH" />
              </Form.Control>
            </Form.Item>
          )}
        </Form.Field>
      </Form.Row>
      <Form.Row>
        <Form.Field name="professional_class_body">
          {({ field }) => (
            <Form.Item>
              <Form.Label>Órgão Classe</Form.Label>
              <Form.Control>
                <Input {...field} placeholder="Ex: CRM, OAB" />
              </Form.Control>
            </Form.Item>
          )}
        </Form.Field>
        <Form.Field name="professional_class_issuer">
          {({ field }) => (
            <Form.Item>
              <Form.Label>Expedidor</Form.Label>
              <Form.Control>
                <Input {...field} placeholder="Expedidor" />
              </Form.Control>
            </Form.Item>
          )}
        </Form.Field>
      </Form.Row>
      <Form.Row>
        <Form.Field name="professional_class_state">
          {({ field }) => (
            <Form.Item>
              <Form.Label>UF</Form.Label>
              <Form.Control>
                <Input {...field} placeholder="Ex: CE" maxLength={2} />
              </Form.Control>
            </Form.Item>
          )}
        </Form.Field>
        <Form.Field name="professional_class_issue_date">
          {({ field }) => (
            <Form.Item>
              <Form.Label>Expedição</Form.Label>
              <Form.Control>
                <Input {...field} type="date" />
              </Form.Control>
            </Form.Item>
          )}
        </Form.Field>
        <Form.Field name="professional_class_expiry_date">
          {({ field }) => (
            <Form.Item>
              <Form.Label>Validade</Form.Label>
              <Form.Control>
                <Input {...field} type="date" />
              </Form.Control>
            </Form.Item>
          )}
        </Form.Field>
      </Form.Row>

      <SectionLabel>Imigração</SectionLabel>
      <Form.Row>
        <Form.Field name="immigration_arrival_year">
          {({ field }) => (
            <Form.Item>
              <Form.Label>Ano de Chegada</Form.Label>
              <Form.Control>
                <Input {...field} placeholder="Ex: 2020" maxLength={4} />
              </Form.Control>
            </Form.Item>
          )}
        </Form.Field>
        <Form.Field name="immigration_visa_type">
          {({ field }) => (
            <Form.Item>
              <Form.Label>Tipo de Visto</Form.Label>
              <Form.Control>
                <Input {...field} placeholder="Tipo de Visto" />
              </Form.Control>
            </Form.Item>
          )}
        </Form.Field>
      </Form.Row>
    </>
  );
};
